export type InterfaceLanguage = 'fr' | 'en';

export function isInterfaceLanguage(value: unknown): value is InterfaceLanguage {
  return value === 'fr' || value === 'en';
}

export function requestedLanguage(): InterfaceLanguage | null {
  if (typeof window === 'undefined') return null;
  const value = new URLSearchParams(window.location.search).get('lang');
  return isInterfaceLanguage(value) ? value : null;
}

export function languageStorageKey(accountId: string): string {
  return `artosera-language:${encodeURIComponent(accountId)}`;
}

// Stockage refusé ou plein : le choix reste actif pour la page courante, comme
// pour le design (`appearance/designStore.ts`). Clés par compte : un autre
// compte n'hérite jamais de ce repli.
const volatile = new Map<string, InterfaceLanguage>();

export function readUserLanguage(accountId: string | null): InterfaceLanguage | null {
  if (!accountId || typeof window === 'undefined') return null;
  const enMemoire = volatile.get(languageStorageKey(accountId));
  if (enMemoire) return enMemoire;
  try {
    const value = window.localStorage.getItem(languageStorageKey(accountId));
    return isInterfaceLanguage(value) ? value : null;
  } catch {
    return null;
  }
}

export function storeUserLanguage(accountId: string, language: InterfaceLanguage): void {
  const key = languageStorageKey(accountId);
  try {
    window.localStorage.setItem(key, language);
    volatile.delete(key);
  } catch {
    // La préférence reste active en mémoire si le stockage est indisponible.
    volatile.set(key, language);
  }
}
